<template>
  <div>
    <!-- Paneli Açma Butonu -->
    <div class="map-filter-panel" />
    <div class="map-container mapfilterss">
      <div class="widgets_inner">
        <div
          class="input-group-icon"
          ng-controller="parameters"
        >
          <div class="input-group">
            <button
              class="btn btn-outline-secondary"
              @click="togglePriceLabels"
            >
              {{ showPrices ? 'Hide Prices' : 'Show Prices' }}
            </button>
            <button
              class="btn btn-outline-secondary"
              @click="getUserLocation"
            >
              Where am I?
            </button>
          </div>
        </div>
      </div>
      <!-- Konumumu Göster Butonu -->
      <!-- Harita Üstü Panel -->
      <div
        ref="sidePanel"
        class="side-panel"
        :class="{ closed: isPanelClosed }"
        :style="{ width: panelWidth + 'px' }"
      >
        <!-- @touchstart="handleTouchStart"
      @touchend="handleTouchEnd" -->
        <button
          class="close-map-listing btn btn-outline-secondary"
          @click="togglePanel"
        >
          {{ isPanelClosed ? 'OPEN' : 'CLOSE' }}
        </button>
        <div class="panel-content">
          <div class="mt-2">
            <select v-model="sortOrder">
              <option value="newest">
                Newest First
              </option>
              <option value="oldest">
                Oldest First
              </option>
              <option value="priceLowToHigh">
                Price: Low to High
              </option>
              <option value="priceHighToLow">
                Price: High to Low
              </option>
            </select>
          </div>
          <ul class="ad-list-map">
            <li
              v-for="ad in sortedAndFilteredPetAds"
              :key="ad.id"
              @click="centerMarker(ad)"
            >
              <div class="feat-post _64kcc76nw">
                <a href="#">
                  <div class="feat-post-icon icon-arrow-wave">0.0 mil</div>
                  <div class="ribbon">£ {{ ad.price }}</div>
                  <div style="display: flex">
                    <div class="feat-post-pic">
                      <div :style="{ backgroundImage: `url(${ad.coverThumbnail || ad.coverImage || 'https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2FnoImage.jpg?alt=media'})` }" />
                    </div>
                    <div class="feat-post-data">
                      <div class="feat-post-title">{{ truncateTitle(ad.title, 50) }}</div>
                      <div class="feat-post-category">{{ ad.category }}</div>
                    </div>
                  </div>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- <button v-if="isPanelClosed" class="open-button" @click="togglePanel">Paneli Aç</button> -->

      <!-- Harita -->
      <div
        v-if="coordinates.length > 0 && startMapRef"
        class="container-fluid map-listing"
        role="application"
        aria-label="Interactive map"
      >
        <l-map
          ref="mapRef"
          :zoom="10"
          :center="coordinates[0] || [51.6518, 0.0589]"
          style="height: 100%; width: 100%"
          tabindex="0"
          @ready="onMapReady"
        >
          <l-tile-layer
            url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
            layer-type="base"
            name="OpenStreetMap"
          />
        </l-map>
      </div>
      <div
        v-else
        class="loading"
      >
        {{ loading && !startMapRef ? 'Map Loading...' : ' Location Searching' }}
      </div>
      <div
        v-if="error"
        class="loading"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useGetPetAds } from '@/composables/getPetAdsMap';
  import { usePetAdsMapStore } from '@/stores/petAdsMapStore'; // Store'u import et
  import { ref, computed, onMounted, watch, onUnmounted } from 'vue';
  import { LMap, LTileLayer } from '@vue-leaflet/vue-leaflet';
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import 'leaflet.markercluster/dist/MarkerCluster.css';
  import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
  import 'leaflet.markercluster';
  import { useRoute, useRouter } from 'vue-router';
  const route = useRoute();
  const router = useRouter();
  const showPrices = ref(false);
  //const markers = ref([]); // Marker referanslarını tutmak için
  const markerClusterGroup = ref(null);

  // Sort order için ref tanımla
  const sortOrder = ref('newest'); // Varsayılan sıralama

  // Fiyat etiketlerini göster/gizle
  const togglePriceLabels = () => {
    showPrices.value = !showPrices.value;
    // Kısa bir gecikme ile güncelle
    setTimeout(updateMarkers, 50);
  };

  const updateMarkers = () => {
    if (!leafletMap.value || !validMarkers.value.length) return;

    // Önce mevcut cluster'ı temizle
    if (markerClusterGroup.value) {
      leafletMap.value.removeLayer(markerClusterGroup.value);
    }

    // Yeni marker cluster oluştur
    markerClusterGroup.value = L.markerClusterGroup({
      maxClusterRadius: 40,
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
      disableClusteringAtZoom: 15,
      animate: false, // Animasyonu devre dışı bırak
      chunkedLoading: true, // Büyük veri setleri için
    });

    // Marker'ları ekle bölümünü güncelleyelim
    validMarkers.value.forEach((ad) => {
      const marker = L.marker([ad.adLocation._lat, ad.adLocation._long]);

      if (showPrices.value) {
        const tooltipContent = `
          <div class="price-tooltip-content">
            <span class="price-tooltip-text">£${ad.price}</span>
          </div>
        `;

        marker.bindTooltip(tooltipContent, {
          permanent: true,
          direction: 'top',
          className: 'price-tooltip',
          noZoomAnimation: true,
          offset: [-15, -20],
        });
      }

      marker.bindPopup(generatePopupContent(ad));
      markerClusterGroup.value.addLayer(marker);
    });

    leafletMap.value.addLayer(markerClusterGroup.value);
  };

  // Ayrıca zoom event'ini dinleyerek tooltip'leri yeniden oluşturabiliriz
  onMounted(async () => {
    try {
      // Store kontrolü
      if (!store.petAdsMap.length) {
        await fetchPetAds();
      }

      // URL filtrelerini uygula
      const queryFilters = {
        category: route.query.category || null,
        subCategory: route.query.subCategory || null,
        priceRange: {
          min: Number(route.query.minPrice) || null,
          max: Number(route.query.maxPrice) || null,
        },
      };
      filters.value = { ...filters.value, ...queryFilters };
      // Koordinatlar hazır olduğunda 3 saniye sonra haritayı göster
      if (coordinates.value.length > 0) {
        setTimeout(() => {
          startMapRef.value = true;
        }, 500);
      }

      // Zoom event listener'ı ekle
      if (leafletMap.value) {
        leafletMap.value.on('zoomend', () => {
          if (showPrices.value) {
            updateMarkers();
          }
        });
      }
    } catch (err) {
      console.error('İlanlar alınamadı:', err);
      store.error = 'Harita verileri yüklenirken bir hata oluştu.';
    }
  });

  import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
  import markerIcon from 'leaflet/dist/images/marker-icon.png';
  import markerShadow from 'leaflet/dist/images/marker-shadow.png';

  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
  });

  // veri çekme işlemleri ve store kullanımı
  const store = usePetAdsMapStore();

  const { fetchPetAds } = useGetPetAds();

  const petAds = computed(() => store.petAdsMap);
  const error = computed(() => store.error);
  const loading = computed(() => store.loading);

  const filters = ref({
    category: null,
    subCategory: null,
    adType: null,
    priceRange: {
      min: null,
      max: null,
    },
    radius: null,
    center: null,
  });

  const filteredPetAds = computed(() => {
    return petAds.value.filter((ad) => {
      // Kategori filtresi
      if (filters.value.category && ad.category !== filters.value.category) {
        return false;
      }

      // Alt kategori filtresi
      if (filters.value.subCategory && ad.subCategory !== filters.value.subCategory) {
        return false;
      }

      // Fiyat aralığı filtresi
      if (filters.value.priceRange.min && ad.price < filters.value.priceRange.min) {
        return false;
      }
      if (filters.value.priceRange.max && ad.price > filters.value.priceRange.max) {
        return false;
      }

      return true;
    });
  });

  // Harita işlemleri
  const mapRef = ref(null);
  const leafletMap = ref(null);
  const userLocation = ref(null);
  const startMapRef = ref(false);

  const coordinates = computed(() => {
    return filteredPetAds.value.map((ad) => [ad.adLocation._lat, ad.adLocation._long]);
  });

  const validMarkers = computed(() => {
    return filteredPetAds.value.filter((ad) => ad.adLocation?._lat && ad.adLocation?._long);
  });

  const onMapReady = (mapInstance) => {
    leafletMap.value = mapInstance;
    leafletMap.value.on('zoomstart', () => {
      if (markerClusterGroup.value) {
        markerClusterGroup.value.eachLayer((layer) => {
          if (layer.getTooltip()) {
            layer.closeTooltip();
          }
        });
      }
    });

    leafletMap.value.on('zoomend', () => {
      if (showPrices.value) {
        // Kısa bir gecikme ekleyerek zoom'un tamamlanmasını bekle
        setTimeout(updateMarkers, 100);
      }
    });

    updateMarkers();
  };

  const generatePopupContent = (ad) => {
    // truncateTitle fonksiyonunu direk burada çağır
    const shortTitle = truncateTitle(ad.title, 40);
    return `
      <div class="custom-popup">
        <div class="leaflet-popup-content" style="width: 301px;">
          <div class="maplink no-hover _3fvmb6x7i" data-link="#" style="cursor: default;">
            <div class="pop-rating">0.0mi</div>
            <div class="pop-img" style="background-image:url('${ad.coverImage || 'https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2FnoImage.jpg?alt=media'}')">
              <div class="ribbon-map">${ad.price}</div>
            </div>
            <div class="icerik">
              <div class="pop-title">${shortTitle}</div>
              <div class="pop-description"></div>
              <div class="pop-category">${ad.category} / ${ad.subCategory}</div>
              <a href="/pets/${ad.id}" target="_blank"><i class="leaflet-popup-go-button"></i></a>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const getUserLocation = async () => {
    if (navigator.permissions) {
      try {
        const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
        if (permissionStatus.state === 'denied') {
          alert('Location access denied. Please enable location access in your browser settings.');
          return;
        }
      } catch (error) {
        console.error('Permission check error:', error);
      }
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          userLocation.value = [position.coords.latitude, position.coords.longitude];
          if (leafletMap.value) {
            L.marker(userLocation.value, {
              icon: L.icon({
                iconUrl: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
                iconSize: [32, 32],
              }),
            })
              .addTo(leafletMap.value)
              .bindPopup('Your Location')
              .openPopup();
            leafletMap.value.flyTo(userLocation.value, 13);
          }
        },
        (error) => {
          console.error('Cant get location ', error);
        },
      );
    } else {
      console.error('Browser does not support geolocation');
    }
  };

  const panelWidth = ref(300);
  const isPanelClosed = ref(false);
  // const touchStartX = ref(0);
  // const touchEndX = ref(0);

  const togglePanel = () => {
    isPanelClosed.value = !isPanelClosed.value;
  };

  const centerMarker = (ad) => {
    if (leafletMap.value) {
      leafletMap.value.setView([ad.adLocation._lat, ad.adLocation._long], 13);
    }
  };

  // İlan başlığını kısaltma fonksiyonu
  const truncateTitle = (title, maxLength = 15) => {
    return title?.length > maxLength ? title.slice(0, maxLength) + '...' : title;
  };

  const sortedAndFilteredPetAds = computed(() => {
    const sorted = [...filteredPetAds.value];

    // Number() dönüşümünü bir kere yapalım
    const sortByPrice = (a, b, isAscending = true) => {
      const priceA = Number(a.price) || 0;
      const priceB = Number(b.price) || 0;
      return isAscending ? priceA - priceB : priceB - priceA;
    };

    switch (sortOrder.value) {
      case 'newest':
        return sorted.sort((a, b) => b.createdAt?.toMillis() - a.createdAt?.toMillis());
      case 'oldest':
        return sorted.sort((a, b) => a.createdAt?.toMillis() - b.createdAt?.toMillis());
      case 'priceLowToHigh':
        return sorted.sort((a, b) => sortByPrice(a, b, true));
      case 'priceHighToLow':
        return sorted.sort((a, b) => sortByPrice(a, b, false));
      default:
        return sorted;
    }
  });
  // Koordinatları izleyen bir watch ekleyelim
  watch(
    coordinates,
    (newCoordinates) => {
      if (newCoordinates.length > 0) {
        // Koordinatlar yüklendiğinde 3 saniye bekle ve haritayı göster
        setTimeout(() => {
          //console.log('Koordinatlar yüklendi, harita gösteriliyor...');
          startMapRef.value = true;
        }, 3000);
      }
    },
    { immediate: true }, // Sayfa yüklendiğinde hemen çalıştır
  );

  // Filtreleri URL'e yansıt
  watch(
    filters,
    (newFilters) => {
      router.push({
        query: {
          ...route.query,
          category: newFilters.category || undefined,
          subCategory: newFilters.subCategory || undefined,
          minPrice: newFilters.priceRange.min || undefined,
          maxPrice: newFilters.priceRange.max || undefined,
        },
      });
    },
    { deep: true },
  );

  // Component temizliği
  onUnmounted(() => {
    if (leafletMap.value) {
      leafletMap.value.off('zoomstart');
      leafletMap.value.off('zoomend');
      if (markerClusterGroup.value) {
        markerClusterGroup.value.clearLayers();
      }
    }
  });
  onMounted(() => {
    setTimeout(() => {
      togglePanel();
    }, 3000);
  });
</script>

<style scoped>
  .panel-content select {
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    font-size: 14px;
  }
  .map-filter-panel {
    position: absolute;
    top: 150px;
    left: 10px;
    z-index: 11000;
  }
  .map-filter-panel button {
    background: #fff;
    border: 1px solid #ddd;
    padding: 5px 10px;
    cursor: pointer;
    z-index: 1100;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .map-filter-panel button:hover {
    background-color: #f9f9f9;
  }

  .map-listing {
    top: 60px;
    padding: 0;
    width: 100%;
    overflow: hidden;
    height: 100vh;
  }
  .ad-list-map {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .side-panel {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    background: #fff;
    border-left: 1px solid #ddd;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    z-index: 998;
    overflow-y: visible !important;
  }

  .side-panel.closed {
    transform: translateX(100%);
  }

  .close-button {
    position: absolute;
    top: 10px;
    left: 10px;
    background: transparent;
    border: none;
    font-size: 18px;
    cursor: pointer;
  }

  .panel-content {
    padding: 0px;
    height: 100%;
    overflow-y: auto;
    margin-top: 0px;
  }

  .map-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 60px);
    font-size: 1.2rem;
    color: #666;
  }
  .widgets_inner {
    padding-left: 0;
    padding-right: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .mapfilterss .input-group-icon {
    position: absolute;
    left: 5px;
    top: 5px;
    z-index: 999;
    border: 1px solid #d66371 !important;
    display: flex;
  }
  .btn-outline-secondary {
    min-height: calc(2.08rem + 2px);
    height: calc(2.08rem + 2px);
    padding-top: 0.27rem !important;
    padding-bottom: 0.27rem;
    transition: all 0.2s linear;
    border-left: 1px solid #dfdede;
    background: white;
  }
  .btn-outline-secondary:hover {
    background-color: #ffdfdf;
  }
  .open-button {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    background: #fff;
    border: 1px solid #ddd;
    padding: 5px 10px;
    cursor: pointer;
    z-index: 1100;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  }

  .show-location-button {
    background: #fff;
    border: 1px solid #ddd;
    padding: 5px 10px;
    cursor: pointer;
    z-index: 1100;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .show-location-button.active {
    background: #f60000;
    color: #dfdede;
    border: 1px solid #ddd;
    padding: 5px 10px;
    cursor: pointer;
    z-index: 1100;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .show-location-button:hover {
    background-color: #fb5050 !important;
  }
  .show-location-button.active:hover {
    background-color: #ffe7e7 !important;
    color: #272323;
  }

  @media screen and (max-width: 492px) {
    .input-group .btn {
      margin: 0 !important;
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }
  .price-tooltip {
    background-color: white;
    border: 2px solid #d66371;
    padding: 4px;
    border-radius: 4px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    pointer-events: none;
  }

  .price-tooltip-content {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .price-tooltip-content {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .price-tooltip-image {
    width: 25px; /* küçülttük */
    height: 25px; /* küçülttük */
    border-radius: 4px;
    object-fit: cover;
    flex-shrink: 0; /* resmin sıkışmasını önler */
  }

  .price-tooltip-text {
    color: #333;
    font-size: 14px;
    white-space: nowrap; /* fiyat tek satırda kalır */
  }
</style>
